import * as React from 'react';
export const ArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24}>
    <defs>
      <clipPath id="a">
        <path fill="#d5d5d6" d="M32 189h24v24H32z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="translate(-32 -189)">
      <g fill="none" stroke="#555658" strokeLinecap="round" strokeWidth={2}>
        <path d="M53 200.995H35" />
        <path d="m35 200.944 6.414 6.424M35 201.046l6.414-6.414" data-name="Line" />
      </g>
    </g>
  </svg>
);
